import React from 'react';
import DepartmentTemplate from './DepartmentTemplate';

const DeptEureEtLoir28 = () => {
  return (
    <DepartmentTemplate
      department="Eure-et-Loir"
      departmentNumber="28"
      cities="Chartres, Dreux, Châteaudun, Nogent-le-Rotrou"
      region="Centre-Val de Loire"
    />
  );
};

export default DeptEureEtLoir28;
